<template>
  <div>
    <Breadcrumbs main="Inventario" title="Editar Categoría" v-if="objectId"/>
    <Breadcrumbs main="Inventario" title="Agregar Categoría" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Editar Categoría</h5>
              <h5 v-else>Agregar Categoría</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label for="name_id">Nombre de la categoría (requerido)</label>
                    <b-form-input
                            type="text" id="name_id" placeholder="Rosé"
                            v-model="form.name.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.name.is_valid">{{form.name.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="parent_id">Es hijo de (opcional)</label>
                    <multiselect placeholder="Selecciona una categoría" id="parent_id"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.parent.value" :options="form.parent.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay categorías disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.parent.is_valid">{{form.parent.message_error}}</b-form-invalid-feedback>
                  </div>
                  <b-button type="button" variant="primary" @click="onSubmit" v-if="objectId">Editar categoría</b-button>
                  <b-button type="button" variant="success" @click="onSubmit" v-else>Agregar categoría</b-button>
                  <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'InventoryCategoryList', params: {clientId: this.clientId}}">Volver</b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import Multiselect from 'vue-multiselect';
  import utils from '../../../utils';

  export default {
    components: {
      Multiselect
    },
    data(){
      return {
        objectId: null,
        clientId: null,
        form: {
          client: utils.defaultFields(),
          name: utils.defaultFields(),
          parent: utils.defaultFields(
              {
                _type: 'select',
                required: false
              }
          ),
        },
      }
    },
    async mounted () {
      this.objectId = this.$route.params.objectId;
      this.clientId = this.$route.params.clientId;
      let typeFilter = '_all_';
      if(this.objectId){
        typeFilter = 'without_child';
        await this.loadData(this.objectId, this.clientId);
      }
      this.form.client.value = this.clientId;
      await this.getTreeCategory(this.form.parent, this.clientId, typeFilter, this.objectId);
      if(this.form['parent'].value === undefined){
        this.form['parent'].value = await this.form['parent'].options.find(item => item['id'] === '');
      }
    },
    methods: {
      onSubmit(evt){
        // console.log(evt)
        evt.preventDefault();
        // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
        let data = {};
        const is_valid = utils.generateJsonStructure(this.form, data);
        if(is_valid){
          let _type = 'agregar la categoría';
          if(this.objectId){
            _type = 'modificar la categoría'
          }
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de ${_type} <b>${this.form.name.value}</b>.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              if(!this.objectId){
                const path = '/api/inventory/v1.0/category/';
                await axios.post(path, data).then(async (response) => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Agregado',
                    type: 'success',
                    html: `Se ha agregado la categoría <b>${this.form.name.value}</b> de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'InventoryCategoryList', params: {clientId: this.clientId}});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  if(error.response.status === 400){
                    console.log(error.response);
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              } else {
                const path = `/api/inventory/v1.0/category/${this.objectId}/`;
                await axios.patch(path, data).then(async (response) => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Modificado',
                    type: 'success',
                    html: `Se ha modificado la categoría <b>${this.form.name.value}</b> de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'InventoryCategoryList', params: {clientId: this.clientId}});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  if(error.response.status === 400){
                    console.log(error.response);
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              }
            }
          });
        }else{
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      async getTreeCategory(inputCategory, clientId, type, categoryId){
        let path;
        if(categoryId){
          path = `/api/inventory/v1.0/tree_category/${categoryId}/`;
        }else{
          path = `/api/inventory/v1.0/tree_category/`;
        }
        const config = {
          params: {
            client_id: clientId,
            type: type,
            status: true
          }
        };
        await axios.get(path, config).then(async (response) => {
          inputCategory.options = response.data;
          inputCategory.value = inputCategory.options.find(option => inputCategory.value === option.id);
        }).catch((error) => {
          console.log(error.response);
        });
      },
      async loadData(objectId, clientId){
        let data = {};
        let responseData;
        const defaultFieldValues = {
          client: {value: clientId},
          parent: {
            _type: 'select',
            required: false
          }
        };
        const path = `/api/inventory/v1.0/category/${objectId}/`;
        await axios.get(path).then(async (response) => {
          responseData = response.data;
          await utils.loadDataStructure(data, responseData, defaultFieldValues);
        }).catch((error) => {
          console.log(error.response);
        });
        await this.$set(
            this,
            'form',
            data
        );
      }
    }
  }
</script>